import React from 'react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 w-full bg-brand-accent text-black py-2 px-4 text-center text-sm font-medium shadow-md" data-id="element-228">
      ⏳ Precio sube a $25 en 48 horas
    </div>;
}